import AppPageList from "./AppPageList";

import "./AppPageList.scss";

export { AppPageList };
